"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regionSelectorDropdownTestId = exports.regionSelectorModalTestId = exports.continueButtonTestId = exports.cancelButtonTestId = exports.continueTranslationLabel = exports.cancelTranslationLabel = exports.regionTranslationLabel = exports.chooseRegionTranslational = void 0;
exports.chooseRegionTranslational = 'choose-region';
exports.regionTranslationLabel = 'region';
exports.cancelTranslationLabel = 'cancel';
exports.continueTranslationLabel = 'continue';
exports.cancelButtonTestId = 'cancel-button';
exports.continueButtonTestId = 'continue-button';
exports.regionSelectorModalTestId = 'region-selector-modal';
exports.regionSelectorDropdownTestId = 'region-selector-dropdown';
//# sourceMappingURL=Constants.js.map